import { render, staticRenderFns } from "./antarkankebaikanCreate.vue?vue&type=template&id=4790d78e&"
import script from "./antarkankebaikanCreate.vue?vue&type=script&lang=js&"
export * from "./antarkankebaikanCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports